module Meevo.Components.Controls {

    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;

    interface IServiceMoverScope extends ng.IScope {
        allSelected: boolean;
    }

    class MeevoServiceMoverController {

        static $inject = [
            '$scope',
            'meevo.components.common.IdentityService'
        ];

        public ngModel: angular.INgModelController;

        public allSelected: boolean;
        public fullResponse: boolean;
        public showCategories: boolean;

        public statusList: { label: string; value: ObjectStateEnum[] }[];
        public servicesStatus: ObjectStateEnum[];

        public serviceCriteria: Object;

        private _selectedCategories: string[];

        get selectedCategories(): string[] {
            return this._selectedCategories;
        }

        set selectedCategories(v: string[]) {
            this._selectedCategories = v;

            this.criteriaUpdated();
        }

        get selectedServices(): string[] {
            return this.ngModel.$viewValue;
        }

        set selectedServices(v: string[]) {
            this.ngModel.$setViewValue(v);
            this.updateValidation();
        }

        constructor(private $scope: IServiceMoverScope,
                    private identityService: Meevo.Components.Common.IIdentityService) {
            this._selectedCategories = [];

            this.fullResponse = true;

            this.statusList = [
                {label: 'LABEL_ACTIVE', value: [ObjectStateEnum.Active]},
                {label: 'LABEL_INACTIVE', value: [ObjectStateEnum.Inactive]},
                {label: 'LABEL_BOTH', value: [ObjectStateEnum.Active, ObjectStateEnum.Inactive]},
            ];

            this.servicesStatus = this.statusList[0].value;

            this.serviceCriteria = {
                serviceCategoryList: this.selectedCategories,
                objectStateEnumList: this.servicesStatus,
                genderEnumList: [92, 93, 94, 2035],
                fieldOrderBy: 'DisplayName',
                orderAscDesc: 'Ascending',
                displayName: null,
                businessTypeList: [this.identityService.businessTypeId],
                locationList: [this.identityService.locationId],
                hierarchyId: null,
                branchId: null
            };
        }

        $onInit() {
            if(typeof this.showCategories === 'undefined') {
                this.showCategories = true;
            }

            this.$scope.$watch(() =>    this.allSelected, (newValue) => {
                this.updateValidation();
            });
        }

        updateValidation() {
            this.ngModel.$setValidity('services', this.allSelected || (!!this.ngModel.$viewValue && this.ngModel.$viewValue.length > 0));
        }

        criteriaUpdated() {
            this.serviceCriteria = angular.extend(this.serviceCriteria, {
                serviceCategoryList: this.selectedCategories,
                objectStateEnumList: this.servicesStatus
            });
        }

    }

    class MeevoServiceMoverDirective implements ng.IDirective {
        restrict = 'E';
        templateUrl = 'app/components/controls/service-mover/service-mover.directive.html';
        scope = {
            fullResponse: '=?',
            allSelected: '=?',
            serviceCategoriesAllCheckboxHidden: '=?',
            servicesAllCheckboxHidden: '=?',
            showCategories: '=?'
        };
        bindToController = true;
        controller = MeevoServiceMoverController;
        controllerAs = '$ctrl';
        require = [
            'meevoServiceMoverDirective',
            'ngModel'
        ];

        link = (scope: any, element: JQuery, attr: angular.IAttributes, [self, ngModel]) => {
            ngModel.$render = () => {
                self.ngModel = ngModel;
                self.$onInit();
            };
        };

        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new MeevoServiceMoverDirective();
            };

            return directive;
        }
    }

    angular.module('meevo.components.controls')
        .directive('meevoServiceMoverDirective', MeevoServiceMoverDirective.factory());
}
